"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SelectPaginationContainer;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
require("../../common/style.scss");
var _componentUtils = require("../../common/componentUtils");
var _intlDesignUi = require("@tencent/intl-design-ui");
require("./index.scss");
var _classnames = _interopRequireDefault(require("classnames"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
// 判断arr2是否包含arr1的内容
const handleArr = (arr1, arr2) => {
  return arr1.filter(val => {
    return arr2.includes(val);
  });
};
function SelectPaginationContainer({
  data,
  children,
  commonStyle,
  domains: domainInfos
}) {
  const color = data.color,
    paddingTopNum = data.paddingTopNum,
    paddingBottomNum = data.paddingBottomNum,
    _data$paginationOpts = data.paginationOpts,
    paginationOpts = _data$paginationOpts === void 0 ? {} : _data$paginationOpts,
    _data$selectorOpts = data.selectorOpts,
    selectorOpts = _data$selectorOpts === void 0 ? {} : _data$selectorOpts,
    _data$textPaginationO = data.textPaginationOpts,
    textPaginationOpts = _data$textPaginationO === void 0 ? {} : _data$textPaginationO,
    _data$textSelectOpts = data.textSelectOpts,
    textSelectOpts = _data$textSelectOpts === void 0 ? {} : _data$textSelectOpts,
    emptyListText = data.emptyListText;
  if (Object.keys(data).length > 1) {
    const style = (0, _componentUtils.doComponentsStyleEvent)({
      color,
      paddingTopNum,
      paddingBottomNum
    }); // 处理组件背景色
    const _useState = (0, _react.useState)('1'),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      pageIndex = _useState2[0],
      setPageIndex = _useState2[1]; // 分页组件默认显示的组件的页
    const _useState3 = (0, _react.useState)('0'),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      total = _useState4[0],
      setTotal = _useState4[1]; // 分页组件总数
    const _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectorRowList = _useState6[0],
      setSelectorRowList = _useState6[1]; // 存储配置的筛选列表
    const _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      filterTypeList = _useState8[0],
      setFilterTypeList = _useState8[1]; // 存储过滤后的索引条件

    // 列表组件的渲染
    const renderChild = child => {
      return child ? /*#__PURE__*/_react.default.cloneElement(child, {
        domains: domainInfos,
        filterOptions: {
          filterTypeList: selectorOpts.isSelector && filterTypeList,
          pageIndex,
          pageSize: paginationOpts === null || paginationOpts === void 0 ? void 0 : paginationOpts.pageSize,
          direction: selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.direction // ui用
        }
      }) : child;
    };

    // 分页组件点击分页索引时的回调函数
    const onPagingChange = ({
      pageIndex
    }) => {
      setPageIndex(pageIndex);
    };

    // 筛选组件添加筛选条件后的回调函数
    const onCallback = dataList => {
      // 没有添加筛选条件
      if (dataList.length === 0) {
        setFilterTypeList([]);
        setTotal(paginationOpts.total);
      } else {
        const formatDataList = selectorOpts.dataList.map(o => o.category.split('/')); // 全部列表的数据，将编辑器配置的分类格式转换为数组
        const res = []; // 存储筛选后的索引列表
        //@ts-ignore
        const resultFilter = dataList.map(o => {
          var _o$children;
          return (_o$children = o.children) !== null && _o$children !== void 0 && _o$children.length ? o.children.map(o => o.key) : [];
        }); // 只需要唯一 key 来匹配
        // 分类逻辑：同样的分类名称下用 || ，不同类别下用 &
        for (let i = 0; i < formatDataList.length; i++) {
          const item = formatDataList[i];
          const formateFilter = resultFilter.map(o => {
            // item是否包含o的内容
            return handleArr(o, item);
          });
          const flag = formateFilter.reduce((prev, cur) => {
            return prev && Boolean(cur.length);
          }, true);
          flag && res.push(i);
        }
        //@ts-ignore
        setTotal(res.length); // 分页的总数重新计算传入
        //@ts-ignore
        setFilterTypeList(res);
      }
      setPageIndex('1'); // 每次添加筛选条件之后索引重置为1
    };

    // 初始化筛选组件数据
    _react.default.useEffect(() => {
      var _selectorOpts$selecto;
      const formatDataList = (_selectorOpts$selecto = selectorOpts.selectorRowList) === null || _selectorOpts$selecto === void 0 ? void 0 : _selectorOpts$selecto.map(item => {
        let children = [];
        if (item.children) {
          children = item.children.map(o => {
            return {
              name: o.name,
              key: o.key
            };
          });
        }
        return {
          aliasName: item.aliasName,
          name: item.name,
          key: item.key,
          children
        };
      });
      setSelectorRowList(formatDataList);
    }, [selectorOpts]);

    // 初始化分页组件数据
    _react.default.useEffect(() => {
      if (paginationOpts !== null && paginationOpts !== void 0 && paginationOpts.total) {
        setPageIndex('1');
        setTotal(paginationOpts.total);
      }
    }, [paginationOpts]);
    return /*#__PURE__*/_react.default.createElement("section", {
      style: style
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        'select-container-col': (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.isSelector) && (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.direction) === 'col'
      })
    }, (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.isSelector) && (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.direction) === 'row' && (selectorRowList === null || selectorRowList === void 0 ? void 0 : selectorRowList.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "select-container-row-pc"
    }, /*#__PURE__*/_react.default.createElement(_intlDesignUi.TreeWide, Object.assign({
      data: selectorRowList,
      onCallback: onCallback
    }, textSelectOpts))), (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.isSelector) && (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.direction) === 'row' && (selectorRowList === null || selectorRowList === void 0 ? void 0 : selectorRowList.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "select-container-row-m"
    }, /*#__PURE__*/_react.default.createElement(_intlDesignUi.TreeVertical, Object.assign({
      data: selectorRowList,
      onCallback: onCallback
    }, textSelectOpts))), (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.isSelector) && (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.direction) === 'col' && (selectorRowList === null || selectorRowList === void 0 ? void 0 : selectorRowList.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: "select-container-col-sticky"
    }, /*#__PURE__*/_react.default.createElement(_intlDesignUi.TreeVertical, Object.assign({
      data: selectorRowList,
      onCallback: onCallback
    }, textSelectOpts))), total && Number(total) ? _react.default.Children.map(children, (child, index) => index === 0 && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)({
        'select-container-col-flex1': (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.isSelector) && (selectorOpts === null || selectorOpts === void 0 ? void 0 : selectorOpts.direction) === 'col'
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: commonStyle,
      key: index
    }, renderChild(child)))) : /*#__PURE__*/_react.default.createElement("div", {
      className: "select-empty"
    }, emptyListText || '暂无符合条件列表，请重新筛选')), (paginationOpts === null || paginationOpts === void 0 ? void 0 : paginationOpts.isPagination) && /*#__PURE__*/_react.default.createElement("div", {
      className: "pagination-container-box"
    }, /*#__PURE__*/_react.default.createElement(_intlDesignUi.Pagination, Object.assign({
      total: (total || 0) && Number(total),
      pageIndex: (pageIndex || 1) && Number(pageIndex),
      pageSize: (paginationOpts.pageSize || 10) && Number(paginationOpts === null || paginationOpts === void 0 ? void 0 : paginationOpts.pageSize),
      onPagingChange: onPagingChange
    }, textPaginationOpts))));
  }
}